const normalizeRole = (role) =>
  String(role || '')
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();

const KDS_BLOCKED_ROLE_TOKENS = [
  'rider',
  'cashier',
  'waiter',
  'server',
  'host',
  'delivery',
  'driver',
  'cleaning',
  'attendant',
];

const isBlockedKdsRole = (normalizedRole) =>
  KDS_BLOCKED_ROLE_TOKENS.some(
    (token) => normalizedRole === token || normalizedRole.includes(token),
  );

/** KDS unlock: kitchen staff, manager, admin (and owner for restaurant oversight). */
export const isKdsEligibleStaff = (staff) => {
  const department = String(staff?.department || '').trim().toLowerCase();
  const normalizedRole = normalizeRole(staff?.role);

  if (!normalizedRole && department !== 'kitchen') return false;
  if (department === 'rider') return false;
  if (isBlockedKdsRole(normalizedRole)) return false;

  if (['admin', 'super admin', 'super_admin', 'owner'].includes(normalizedRole)) {
    return true;
  }

  if (normalizedRole === 'manager' || normalizedRole.includes('manager')) {
    return true;
  }

  if (department === 'kitchen') {
    return true;
  }

  if (
    ['chef', 'cook', 'kitchen', 'kitchen staff', 'line cook', 'prep cook', 'sous chef', 'head chef'].includes(
      normalizedRole,
    )
  ) {
    return true;
  }

  if (
    normalizedRole.includes('chef') ||
    normalizedRole.includes('kitchen') ||
    normalizedRole.includes('cook')
  ) {
    return true;
  }

  return false;
};
